import { render, staticRenderFns } from "./LastActivity.vue?vue&type=template&id=031b47d7&"
import script from "./LastActivity.vue?vue&type=script&lang=js&"
export * from "./LastActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LastActivity.vue"
export default component.exports